
import * as types from './types';
import { JSON_STRING, HttpClient, MHTTPCL } from '../../../../services/http/http-client';
import { CustomTextService } from '../../services/custom-texts.service';
import { SETTINGS_URL } from '../../../../services/common-urls';

// Action Object for Custom_textsSettings. Import the types from custom_texts/types.js and Invoke Actions from the Vuex Host Components.

export const custom_textsSettingsActions = {
  async [types.Custom_textsSettingsData.FETCH.ALL]({ commit, getters, dispatch }, payload) {

    // Settings -> Custom Texts -> Assistant Intelligence - was removed from V1 later
    // 'assistant_intelligence': CustomTextService.findAssistantIntelligence(),

    const custom_textsSettingsData = await HttpClient.mergePromiseDict({
      'template': CustomTextService.findTemplates(),
      'offer_mail_to_artist': CustomTextService.findArtistTemplates(),
      'request_form_mail': CustomTextService.findMailTemplates(),
      'promoter_questionnaire_mail': CustomTextService.findQuestionnaireTemplates(),
      'booking_document_and_files': CustomTextService.findDocumentTemplates(),
      'assistant_intelligence': CustomTextService.findAssistantIntelligence(),
      // Newer Additions

      'royalty_statement_email': CustomTextService.findTemplatesByTemplateKey('royalty_statement_email'),
      'po_reception_email': CustomTextService.findTemplatesByTemplateKey('po_reception_email'),
    });
    console.log(custom_textsSettingsData);
    commit(types.Custom_textsSettingsData.SET.ALL, custom_textsSettingsData);
  },
  async [types.Templates.SET.ALL]({ getters, commit }, payload) {
    commit(types.Custom_textsSettingsData.SET.ALL, payload);
  },
  async [types.Templates.UPDATE.SINGLE]({ getters, dispatch }, payload) {
    console.log(payload);

    const { item, name, value, template_key } = payload;
    const { template_id } = item;

    dispatch(types.Templates.SET.ALL, {
      ...getters.custom_textsSettingsData,
      [template_key]: {
        ...getters.custom_textsSettingsData[template_key],
        templates: getters.custom_textsSettingsData[template_key].templates.map(template => {
          if (template.template_id == template_id) {
            return {
              ...template,
              [name]: value
            };
          } else {
            return template;
          }
        })
      }
    });

    const updatedTemplate = await MHTTPCL.modify(
      'template_id',
      template_id,
      name,
      value,
      'text_library',
    );
  },
  async [types.Templates.INSERT.SINGLE]({ getters, dispatch }, payload) {
    const { template_key, description, template_text } = payload;

    const insertedTemplate = await MHTTPCL.post(SETTINGS_URL, {
      section: 'templates',
      action: 'add_new',
      template_key,
      description,
      template_text
    }).then(res => res.data);

    dispatch(types.Templates.SET.ALL, {
      ...getters.custom_textsSettingsData,
      [template_key]: {
        ...getters.custom_textsSettingsData[template_key],
        templates: insertedTemplate.templates
      },
      new_template_id: insertedTemplate.new_template_id
    });

    setTimeout(() => {
      dispatch(types.Templates.SET.ALL, {
        ...getters.custom_textsSettingsData,
        new_template_id: undefined
      });
    }, 100);
  },
  async [types.Templates.DELETE.SINGLE]({ getters, dispatch }, payload) {
    const { template_key, template_id } = payload;

    dispatch(types.Templates.SET.ALL, {
      ...getters.custom_textsSettingsData,
      [template_key]: {
        ...getters.custom_textsSettingsData[template_key],
        templates: getters.custom_textsSettingsData[template_key].templates.filter(template => {
          if (template.template_id == template_id) {
            return false;
          } else {
            return true;
          }
        })
      }
    });

    const deletedTemplate = await MHTTPCL.post(SETTINGS_URL, {
      section: 'templates',
      action: 'delete',
      template_id
    });
  },
}
